export class TopicTextGenerator {
    private text: string;
    private itemCount: number = 0;

    constructor(action: TopicAction) {
        this.text = `${action}`;
    }

    private updateText = (newText: string) => {
        this.text = newText;
        return this;
    };

    private and = (item: string) => `${this.text} and ${item}`;

    public plural = () => this.updateText(`${this.text}s`);

    public add = (item: string) => {
        this.itemCount++;
        const newText = this.itemCount > 1 ? this.and(item) : `${this.text} ${item}`;
        return this.updateText(newText);
    };

    public toLowerCase = () => this.updateText(this.text.toLocaleLowerCase());

    public get = () => this.text;
}

export enum TopicItem {
    topic = "Topic",
    topicGroup = "Topic Group"
}

export enum TopicAction {
    delete = "Delete",
    empty = ""
}

export const getStateUpdateMessage = (topicsCount: number, disable: boolean) => {
    const verb = disable ? "disabled" : "enabled";
    const s = topicsCount > 1 ? "s" : "";
    return `Successfully ${verb} topic${s}.`;
};

export const getDeleteMessage = (topicCount: number, groupCount: number) => {
    const snackbar = new TopicTextGenerator(TopicAction.empty);

    if (groupCount > 0) {
        snackbar.add(TopicItem.topicGroup);
        if (groupCount > 1) {
            snackbar.plural();
        }
    }

    if (topicCount > 0) {
        snackbar.add(TopicItem.topic);
        if (topicCount > 1) {
            snackbar.plural();
        }
    }

    return `Successfully deleted unused ${snackbar.toLowerCase().get()}.`;
};